import { render, staticRenderFns } from "./dlgResult.vue?vue&type=template&id=1766c2cf"
import script from "./dlgResult.vue?vue&type=script&lang=js"
export * from "./dlgResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports